import * as React from 'react'

import { format } from 'date-fns'
import { localeMap } from '../../util/localeMap'
import { Calendar as CalendarIcon } from 'lucide-react'

import { cn } from '../../lib/utils'
import { Button } from '../../lib/ui/button'
import { Calendar } from '../../lib/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '../../lib/ui/popover'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../lib/ui/form'

export function DatePickerField({
  control,
  name,
  label,
  description,
  className,
  disabled,
  notRounded,
  buttonWidth,
  innerClassName,
  pickDate,
  locale,
}) {
  const localeObj = localeMap(locale)
  const [open, setOpen] = React.useState(false)

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(className, 'flex flex-col')}>
          <FormLabel>{label}</FormLabel>
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <FormControl>
                <Button
                  variant={'outline'}
                  className={cn(
                    notRounded ? 'rounded-[5px]' : '',
                    'w-[240px] pl-3 text-left font-normal',
                    !field.value && 'text-muted-foreground',
                    buttonWidth,
                    innerClassName,
                  )}
                >
                  {field.value ? (
                    format(field.value, 'PPP', { locale: localeObj })
                  ) : (
                    <span>{pickDate}</span>
                  )}
                  <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                </Button>
              </FormControl>
            </PopoverTrigger>
            <PopoverContent
              className="z-[1090] w-auto p-0"
              align="start"
              aria-label={label}
            >
              <Calendar
                mode="single"
                selected={field.value}
                onSelect={(date) => {
                  field.onChange(date)
                  setOpen(false)
                }}
                disabled={disabled}
                initialFocus
              />
            </PopoverContent>
          </Popover>
          <FormDescription>{description}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
